import React from 'react'; // define a React Context to pull dataProviders from
// This Context is internal, and is not exposed publicly
// from the `@nerdwallet/structured-content-core` package

var DataProvidersContext = /*#__PURE__*/React.createContext();
export default DataProvidersContext;